import * as React from 'react';
import { RadioButtonGroup } from '@roger/ui-components';

import type { ChannelKind } from '../../services/api/types.gen';

/** The same two words as the Group Manager Channel column. */
const OPTIONS: Array<{ value: ChannelKind; label: string }> = [
  { value: 'conversation', label: 'Conversation' },
  { value: 'announcement', label: 'Announcements' },
];

/** One line on the consequence, so the choice needs no help text. */
const HINTS: Record<ChannelKind, string> = {
  conversation: 'Everyone can post.',
  announcement: 'Only announcers can post.',
};

type GroupKindFieldProps = {
  value: ChannelKind;
  onChange: (kind: ChannelKind) => void;
  disabled?: boolean;
};

/** Conversation or Announcements, in the new-group dialog and the editor. */
export function GroupKindField({
  value,
  onChange,
  disabled,
}: GroupKindFieldProps) {
  const hintId = React.useId();
  return (
    <div className='flex min-w-0 flex-col gap-2'>
      <h3 className='text-sm font-medium'>Channel</h3>
      <RadioButtonGroup
        aria-label='Channel'
        aria-describedby={hintId}
        orientation='horizontal'
        options={OPTIONS}
        value={value}
        disabled={disabled}
        // allowDeselect is off, so the value is always one of the options.
        onValueChange={next => onChange(next as ChannelKind)}
      />
      <p id={hintId} className='text-xs text-muted-foreground'>
        {HINTS[value]}
      </p>
    </div>
  );
}
